
















































































































import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import InputWrapper from '@/componentsV2/molecules/Inputs/InputWrapper.vue';

import eventBus from '@/utils/eventBus';

import InviteMerchantSignupModalsModel from '@/views/Models/InviteMerchantSignupModalsModel.vue';

export interface IPersonalInfo {
  managerName: string;
  managerLastName: string;
  managerMail: string;
}

@Component({
  components: {
    Typography,
    CloseModalIcon,
    FilledButton,
    TextField,
    InputWrapper,
    ValidationObserver,
    ValidationProvider
  }
})
export default class EditPersonalInfo extends Mixins(
  Vue,
  InviteMerchantSignupModalsModel
) {
  @Prop() readonly code!: string;
  @Prop() readonly initialData!: IPersonalInfo;
  @Prop() readonly onSuccess?: (newData?: IPersonalInfo) => void;

  form = {
    managerName: this.initialData.managerName,
    managerLastName: this.initialData.managerLastName,
    managerMail: this.initialData.managerMail
  };

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  get hasChanges() {
    return (
      this.form.managerName !== this.initialData.managerName ||
      this.form.managerLastName !== this.initialData.managerLastName
    );
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (!formIsValid) return;

    if (!this.hasChanges) {
      this.onClose();
      return;
    }

    this.submitLoading = true;

    const response = await this.service.updatePersonalInfo(this.code, {
      name: this.form.managerName,
      lastname: this.form.managerLastName
    });

    this.submitLoading = false;

    if (response.status === 200) {
      if (this.onSuccess) this.onSuccess(this.form);
    }

    this.onClose();
  }
}
